import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React from 'react';
import OnBoardingPopUp from '../../_components/molecules/OnBoardingPopup';
import { HOME_SCREEN } from '../../core-utils/routes';
import { onBoardingStatusMessages } from '../../core-utils/messages/OnBoardingStatusMessages';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';

const useStyles = makeStyles()({
  mainDiv: {
    width: '1182px',
    padding: '40px 10px 36px 63px',
  },
  titleSubtitle: {
    width: '1182px',
    marginBottom: '30px',
  },
});

const OnBoardingStatusPage: React.FC = observer(({}) => {
  const { classes } = useStyles();
  const messages = onBoardingStatusMessages.ON_BOARDINGSTATUS_PAGE;
  const messages2 = contractAIQConstants.COMPLIANCE_ASSURANCE.ONBOARDING;

  return (
    <Grid className={classes.mainDiv}>
      <Grid className={classes.titleSubtitle}>
        <PageTitleAndSubTitle
          title={messages2.TITLE}
          subTitle={messages2.SUB_TITLE}
        />
      </Grid>
      <Grid>
        <OnBoardingPopUp
          title={messages.TITLE}
          subTitle={messages.SUBTITLE}
          statusTitles={messages.STATUS_TITLES}
          locateTitle={messages.LOCATE_TITLE}
          locateLink={HOME_SCREEN}
        />
      </Grid>
    </Grid>
  );
});

export default OnBoardingStatusPage;
